export default function ThankYouIcon() {
  return (
    <svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z'
        fill='#DCFCE7'
      />
      <path
        d='M40.0007 56.6663C49.2054 56.6663 56.6673 49.2044 56.6673 39.9997C56.6673 30.7949 49.2054 23.333 40.0007 23.333C30.7959 23.333 23.334 30.7949 23.334 39.9997C23.334 49.2044 30.7959 56.6663 40.0007 56.6663Z'
        stroke='#00A63E'
        stroke-width='3.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M35 40.0003L38.3333 43.3337L45 36.667'
        stroke='#00A63E'
        stroke-width='3.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
